import React from "react";

import { Route } from "react-router";

import Locus from "./locus";

function MundoApto() {
  return (
    <>
      <Route path="/locus/locus">
        <Locus />
      </Route>
    </>
  );
}

export default MundoApto;
